import jwtDecode from "jwt-decode";
import accessToken from "./jwt-token-access/accessToken";

export const SSO_COGNITO_HOST = "cloudcatcher-dashboard.auth.us-east-1.amazoncognito.com";

export const SSO_EMAIL_KEY = "cc.sso.email";
export const SSO_STATE_KEY = "cc.sso.state";
export const SSO_VERIFIER_KEY = "cc.sso.codeVerifier";
export const SSO_REDIRECT_URI_KEY = "cc.sso.redirectUri";

export const SSO_GENERIC_ERROR =
  "Single Sign-On could not be completed. Please try again or contact your administrator.";

export function clearSsoSessionKeys() {
  [SSO_EMAIL_KEY, SSO_STATE_KEY, SSO_VERIFIER_KEY, SSO_REDIRECT_URI_KEY].forEach((key) =>
    sessionStorage.removeItem(key)
  );
}

export function isCognitoUrl(value) {
  try {
    const parsed = new URL(value);
    return parsed.protocol === "https:" && parsed.host === SSO_COGNITO_HOST;
  } catch (error) {
    return false;
  }
}

/** Cognito adds the `identities` claim only to federated (SSO) users' ID tokens. */
export function isSsoSession() {
  try {
    const token = accessToken();
    if (!token) return false;
    const { identities } = jwtDecode(token);
    return Array.isArray(identities) && identities.length > 0;
  } catch (error) {
    return false;
  }
}

/** Password routes reject SSO users with HTTP 400 `{ message, displayName }`; null for any other body. */
export function formatSsoPasswordRejection(data) {
  if (!data || typeof data !== "object") return null;
  const { message, displayName } = data;
  if (typeof message !== "string" || !message.trim() || typeof displayName !== "string" || !displayName.trim()) {
    return null;
  }
  return `${message.trim()} Identity provider: ${displayName.trim()}.`;
}

/** logoutUrl from the SSO exchange, or null for legacy sessions. */
export function getSsoLogoutUrl() {
  try {
    const logoutUrl = JSON.parse(localStorage.getItem("authUser") || "null")?.logoutUrl;
    return logoutUrl && isCognitoUrl(logoutUrl) ? logoutUrl : null;
  } catch (error) {
    return null;
  }
}
